const RightPanel = ({ children }) => {
  return (
    <div className="col-md-9">
      <div>{children}</div>
    </div>
  );
};

export default RightPanel;
